"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1233],{

/***/ 84085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(11355);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(99545);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16606);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(62099);
/* harmony import */ var components_Shared_Pagination__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74469);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30381);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63651);
/* harmony import */ var components_Shared_specific_loading_spinner_SpecificLoadingSpinner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12556);
/* harmony import */ var components_Shared_DGA_inputs_DGA_dropdown_input__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15825);
/* harmony import */ var src_util_ScrollTopUsingGsap__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88381);
/* harmony import */ var lib_UrlSanitization_YoutubeEmbedSanitization__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50733);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
















var Podcasts = function(props) {
    var closeModal = function closeModal() {
        setIsOpen(false);
        setVideoURL("");
    };
    var openModal = function openModal(link) {
        setVideoURL(typeof link === "string" ? link : "");
        setIsOpen(true);
    };
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        id: 1,
        name: props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonText) === null || ref1 === void 0 ? void 0 : ref1.value,
        sortValue: null,
        unavailable: false
    }), selectedSortOption = ref14[0], setSelectedSortOption = ref14[1];
    var itemsPerPage = 9;
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), currentPage = ref15[0], setCurrentPage = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), videoURL = ref16[0], setVideoURL = ref16[1];
    var safeVideoEmbedSrc = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,lib_UrlSanitization_YoutubeEmbedSanitization__WEBPACK_IMPORTED_MODULE_9__/* .sanitizeYouTubeEmbedSrc */ .C)(videoURL);
    }, [
        videoURL
    ]);
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), listData = ref17[0], setListData = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), loading = ref18[0], setLoading = ref18[1];
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), error = ref19[0], setError = ref19[1];
    var container = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var sortItemsList = [
        {
            id: 1,
            name: props.locale === (props === null || props === void 0 ? void 0 : props.lang) ? props.locale === "ar" ? "الأحدث" : props.locale === "zh" ? "最新" : props.locale === "ko" ? "최신순" : "Newest" : "Newest",
            sortValue: true,
            unavailable: false
        },
        {
            id: 2,
            name: props.locale === (props === null || props === void 0 ? void 0 : props.lang) ? props.locale === "ar" ? "الأقدم" : props.locale === "zh" ? "最旧" : props.locale === "ko" ? "오래된순" : "Oldest" : "Oldest",
            sortValue: false,
            unavailable: false
        }, 
    ];
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isOpen = ref20[0], setIsOpen = ref20[1];
    var getListData = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(function() {
            var res, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_11__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            axios__WEBPACK_IMPORTED_MODULE_5___default()({
                                url: "".concat("https://c-admin.takamulstg.com", "/api/Podcast/GetPodcasts"),
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                data: {
                                    culture: props === null || props === void 0 ? void 0 : props.locale,
                                    PageSize: currentPage - 1,
                                    PageNumber: itemsPerPage,
                                    order: (selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.id) == 1 ? "desc" : "asc",
                                    title: ""
                                }
                            })
                        ];
                    case 2:
                        res = _state.sent();
                        setListData(res.data);
                        setError(false);
                        setLoading(false); // Update listData with the response data
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        // Handle error
                        setError(true);
                        setLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function getListData() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        getListData();
    }, [
        selectedSortOption,
        currentPage,
        props.locale
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref, ref1;
        setSelectedSortOption({
            id: 1,
            name: props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonText) === null || ref1 === void 0 ? void 0 : ref1.value,
            sortValue: null,
            unavailable: false
        });
        setCurrentPage(1);
    }, [
        props.locale
    ]);
    var onPageChange = function(newPage) {
        setLoading(true);
        (0,src_util_ScrollTopUsingGsap__WEBPACK_IMPORTED_MODULE_12__/* .scrollToTopSafe */ .q)();
        setTimeout(function() {
            setCurrentPage(newPage);
        }, 250);
    };
    // if (loading) {
    //   return <SpecificLoadingSpinner />;
    // }
    if (error) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "min-h-screen",
            children: "error"
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "bg-primary-50 py-10",
                children: [
                    (props === null || props === void 0 ? void 0 : (ref2 = props.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.title) === null || ref3 === void 0 ? void 0 : ref3.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "responsive font-bold text-3xl md:text-4xl md:font-semibold ",
                        children: props === null || props === void 0 ? void 0 : (ref4 = props.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.title) === null || ref5 === void 0 ? void 0 : ref5.value
                    }),
                    (props === null || props === void 0 ? void 0 : (ref6 = props.fields) === null || ref6 === void 0 ? void 0 : ref6.description) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "responsive pt-4 text-base",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_13__/* .RichText */ .H, {
                            field: props === null || props === void 0 ? void 0 : (ref7 = props.fields) === null || ref7 === void 0 ? void 0 : ref7.description
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "responsive mt-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full flex justify-end",
                            children: !loading && (listData === null || listData === void 0 ? void 0 : (ref8 = listData.PodcastData) === null || ref8 === void 0 ? void 0 : ref8.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "self-start md:mt-0 mt-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: " relative z-20 min-w-[200px] flex justify-end",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_DGA_inputs_DGA_dropdown_input__WEBPACK_IMPORTED_MODULE_8__["default"], {
                                        value: selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.id,
                                        options: sortItemsList.map(function(item) {
                                            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({}, item), {
                                                label: item.name,
                                                value: item === null || item === void 0 ? void 0 : item.id
                                            });
                                        }),
                                        maxHeight: 300,
                                        closeAfterSelect: true,
                                        onChange: function(selected) {
                                            if (selected) {
                                                var selectedSortItem = sortItemsList.find(function(item) {
                                                    return (item === null || item === void 0 ? void 0 : item.id) === selected;
                                                });
                                                setSelectedSortOption(selectedSortItem);
                                            } else {
                                                var ref, ref1;
                                                setSelectedSortOption({
                                                    id: 0,
                                                    name: props === null || props === void 0 ? void 0 : (ref = props.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.buttonText) === null || ref1 === void 0 ? void 0 : ref1.value,
                                                    sortValue: null,
                                                    unavailable: false
                                                });
                                            }
                                        },
                                        InputSize: "lg",
                                        name: "publication-pages-sort-dropdown",
                                        variant: "default",
                                        placeholder: selectedSortOption ? selectedSortOption.name : props === null || props === void 0 ? void 0 : (ref9 = props.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.buttonText) === null || ref10 === void 0 ? void 0 : ref10.value,
                                        mainDropdownContainerClassName: "max-w-[121px] md:max-w-[250px] w-full"
                                    })
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                ref: container,
                className: " responsive py-10 ".concat((props === null || props === void 0 ? void 0 : props.locale) == (props === null || props === void 0 ? void 0 : props.lang) ? "rtl" : ""),
                children: [
                    !loading && !error && (listData === null || listData === void 0 ? void 0 : (ref11 = listData.PodcastData) === null || ref11 === void 0 ? void 0 : ref11.length) <= 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-[#142836] text-base md:text-lg lg:text-xl font-normal",
                            children: (props === null || props === void 0 ? void 0 : props.locale) == (props === null || props === void 0 ? void 0 : props.lang) ? "قريبا" : "Coming Soon"
                        })
                    }),
                    loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_specific_loading_spinner_SpecificLoadingSpinner__WEBPACK_IMPORTED_MODULE_7__.SpecificLoadingSpinner, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 overflow-hidden",
                        children: !loading && (listData === null || listData === void 0 ? void 0 : (ref12 = listData.PodcastData) === null || ref12 === void 0 ? void 0 : ref12.length) > 0 && (listData === null || listData === void 0 ? void 0 : (ref13 = listData.PodcastData) === null || ref13 === void 0 ? void 0 : ref13.map(function(item, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: " animate-top-dga p-4 rounded-2xl border border-neutral-300 flex justify-between flex-col gap-8",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col gap-8 h-full",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "relative h-[160px] md:h-[250px] w-full bg-neutral-50",
                                                children: (item === null || item === void 0 ? void 0 : item.Image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    src: (item === null || item === void 0 ? void 0 : item.Image) ? "https://c-admin.takamulstg.com" + (item === null || item === void 0 ? void 0 : item.Image) : "/event-placeholder.jpg",
                                                    alt: (item === null || item === void 0 ? void 0 : item.Title) || (item === null || item === void 0 ? void 0 : item.Description) || "Podcast thumbnail ".concat(index + 1),
                                                    layout: "fill",
                                                    objectFit: "cover",
                                                    objectPosition: "center",
                                                    className: "rounded-lg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-col gap-2 flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                        className: "text-lg font-bold",
                                                        children: item === null || item === void 0 ? void 0 : item.Title
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                        className: "text-base line-clamp-4 mt-auto",
                                                        children: [
                                                            item === null || item === void 0 ? void 0 : item.SubTitle,
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex justify-between items-center",
                                            children: [
                                                (item === null || item === void 0 ? void 0 : item.date) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "p-2 py-[3px] border border-neutral-300 text-xs font-medium bg-neutral-100 rounded",
                                                    children: [
                                                        moment__WEBPACK_IMPORTED_MODULE_4___default()(item === null || item === void 0 ? void 0 : item.date).locale(props === null || props === void 0 ? void 0 : props.locale).format("DD MMMM YYYY"),
                                                        " "
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_6__.DGAButton, {
                                                    size: "iconOnly md",
                                                    variant: "secondarySolid",
                                                    onClick: function() {
                                                        if (item === null || item === void 0 ? void 0 : item.VideoID) openModal(item === null || item === void 0 ? void 0 : item.VideoID);
                                                    },
                                                    disabled: !(item === null || item === void 0 ? void 0 : item.VideoID),
                                                    "aria-label": "Play video: ".concat((item === null || item === void 0 ? void 0 : item.Title) || "podcast"),
                                                    buttonContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        "aria-hidden": "true",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                clipRule: "evenodd",
                                                                d: "M13.5886 9.03673L13.507 8.98624C12.8503 8.57997 12.2993 8.23909 11.8422 8.02739C11.3786 7.81269 10.85 7.65067 10.2988 7.82076C9.93447 7.93318 9.6108 8.14417 9.35518 8.42499C8.98329 8.83355 8.86071 9.36753 8.80525 9.90122C8.74997 10.4331 8.74998 11.1202 8.75 11.9569V12.0429C8.74998 12.8796 8.74997 13.5667 8.80525 14.0986C8.86071 14.6323 8.98329 15.1662 9.35518 15.5748C9.6108 15.8556 9.93447 16.0666 10.2988 16.179C10.85 16.3491 11.3786 16.1871 11.8422 15.9724C12.2993 15.7607 12.8503 15.4198 13.507 15.0135L13.5886 14.9631C14.2703 14.5414 14.8387 14.1898 15.2505 13.8622C15.6745 13.525 16.0479 13.1264 16.1821 12.5709C16.2726 12.1964 16.2726 11.8034 16.1821 11.4289C16.0479 10.8734 15.6745 10.4748 15.2505 10.1376C14.8387 9.81 14.2703 9.45843 13.5886 9.03673ZM10.4645 9.4347C10.5477 9.34324 10.6442 9.28396 10.7411 9.25408C10.7497 9.25136 10.8484 9.2202 11.2118 9.38849C11.5766 9.55745 12.0502 9.84885 12.7593 10.2875C13.4916 10.7405 13.9829 11.0459 14.3168 11.3115C14.6466 11.5738 14.7069 11.7101 14.7241 11.7813C14.7586 11.9242 14.7586 12.0756 14.7241 12.2185C14.7069 12.2897 14.6466 12.4259 14.3168 12.6883C13.9829 12.9539 13.4916 13.2592 12.7593 13.7122C12.0502 14.1509 11.5766 14.4423 11.2118 14.6113C10.8484 14.7796 10.7497 14.7484 10.7411 14.7457C10.6442 14.7158 10.5477 14.6565 10.4645 14.5651C10.4265 14.5234 10.3442 14.3956 10.2972 13.9435C10.251 13.4986 10.25 12.8902 10.25 11.9999C10.25 11.1095 10.251 10.5012 10.2972 10.0563C10.3442 9.60414 10.4265 9.47636 10.4645 9.4347Z",
                                                                fill: "currentColor"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                fillRule: "evenodd",
                                                                clipRule: "evenodd",
                                                                d: "M12 1.25C6.06294 1.25 1.25 6.06294 1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25ZM2.75 12C2.75 6.89137 6.89137 2.75 12 2.75C17.1086 2.75 21.25 6.89137 21.25 12C21.25 17.1086 17.1086 21.25 12 21.25C6.89137 21.25 2.75 17.1086 2.75 12Z",
                                                                fill: "currentColor"
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, index);
                        }))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_16__/* .Transition */ .u, {
                        appear: true,
                        show: isOpen,
                        as: react__WEBPACK_IMPORTED_MODULE_2__.Fragment,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_17__/* .Dialog */ .V, {
                            as: "div",
                            className: "relative z-[999999]",
                            onClose: closeModal,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_16__/* .Transition.Child */ .u.Child, {
                                    as: react__WEBPACK_IMPORTED_MODULE_2__.Fragment,
                                    enter: "ease-out duration-300",
                                    enterFrom: "opacity-0",
                                    enterTo: "opacity-100",
                                    leave: "ease-in duration-200",
                                    leaveFrom: "opacity-100",
                                    leaveTo: "opacity-0",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "fixed inset-0 bg-black bg-opacity-50"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "fixed inset-0 overflow-hidden",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "flex min-h-full items-center justify-center p-4 text-center",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_16__/* .Transition.Child */ .u.Child, {
                                            as: react__WEBPACK_IMPORTED_MODULE_2__.Fragment,
                                            enter: "ease-out duration-300",
                                            enterFrom: "opacity-0 ",
                                            enterTo: "opacity-100",
                                            leave: "ease-in duration-200",
                                            leaveFrom: "opacity-100",
                                            leaveTo: "opacity-0 ",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_17__/* .Dialog.Panel */ .V.Panel, {
                                                className: "aspectRationdiv transform overflow-hidden bg-white text-left align-middle transition-all",
                                                children: safeVideoEmbedSrc ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                                    title: "Embedded video player",
                                                    width: "100%",
                                                    height: "100%",
                                                    // sandbox="allow-scripts allow-same-origin allow-presentation allow-popups"
                                                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                                    allowFullScreen: true,
                                                    referrerPolicy: "strict-origin-when-cross-origin",
                                                    sandbox: "allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox",
                                                    src: safeVideoEmbedSrc
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "flex min-h-[240px] w-full items-center justify-center p-6 text-center text-sm text-neutral-800",
                                                    children: (props === null || props === void 0 ? void 0 : props.locale) === (props === null || props === void 0 ? void 0 : props.lang) ? "تعذر تحميل الفيديو" : "Video could not be loaded"
                                                })
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "responsive border-4 border-white flex justify-end w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_Pagination__WEBPACK_IMPORTED_MODULE_1__["default"], {
                    currentPage: currentPage,
                    setCurrentPage: setCurrentPage,
                    totalItems: listData === null || listData === void 0 ? void 0 : listData.TotalItemsCount,
                    itemsPerPage: itemsPerPage,
                    onPageChange: onPageChange,
                    maxPages: 5,
                    locale: props === null || props === void 0 ? void 0 : props.locale,
                    lang: props === null || props === void 0 ? void 0 : props.lang,
                    scrollToRef: null
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_18__/* .withDatasourceCheck */ .C)()(Podcasts));


/***/ })

}]);